import { Rotation, ZoomState } from '.';
export type Prediction = {
  location: number[];
  page: number;
};

export const drawPredictions = (
  canvas: HTMLCanvasElement,
  predictions: Prediction[],
  zoom: ZoomState,
  rotation: Rotation,
  predictionsFillStyle?: string,
  globalCompositeOperation?: string,
  sizeMultiple = 1000
): void => {
  const context = canvas?.getContext('2d');
  if (!context) {
    return;
  }

  let x = 0;
  let y = 0;
  let w = 1;
  let h = 1;

  context.save();
  const { width, height } = canvas;
  context.globalCompositeOperation = globalCompositeOperation || 'source-over';

  for (const prediction of predictions) {
    x = prediction.location[0];
    y = prediction.location[1];
    w = prediction.location[2] * zoom * sizeMultiple;
    h = prediction.location[3] * zoom * sizeMultiple;
    let finalX = 0;
    let finalY = 0;
    if (rotation === 90) {
      finalX = width - y * width;
      finalY = x * height;
    } else if (rotation === 270) {
      finalX = y * width;
      finalY = height - x * height;
    } else if (rotation === 180) {
      finalX = width - x * width;
      finalY = height - y * height;
    } else {
      finalX = width * x;
      finalY = height * y;
    }

    finalX -= w / 2;
    finalY -= h / 2;

    context.fillStyle = predictionsFillStyle || 'green';

    context.beginPath();
    context.ellipse(finalX, finalY, w, h, 0, 0, 2 * Math.PI);
    context.filter = 'blur(20px)';
    context.fill();
    context.stroke();
  }

  context.restore();
};
